module.exports = __webpack_public_path__ + "img/urartu-logo-icon.a641c787.png";